

































































    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component({
        name: "ProfileLayout",
        components: {},
        mixins:[]
    })
    export default class ProfileLayout extends Vue {
        public created():void {
            // on componenet created
        }
        public mounted():void {
            // on componenet mounted
        }
    }
